/* eslint-disable no-null/no-null */
export function isDefined<T>(value: T | null | undefined): value is T {
  return value !== undefined && value !== null;
}
/* eslint-enable no-null/no-null */
